import { useContext } from "react";
import { AdmContext } from "../contexts/AdmContext";

export function useAdmContext() {
  return useContext(AdmContext);
}